

export const frontMatter = {
	slug: 'dockview-1.10.0-release',
	title: 'Dockview 1.10.0',
	tags: [
		'release'
	]
};
export const contentTitle = 'Release Notes';
export const metadata = {
  "permalink": "/blog/dockview-1.10.0-release",
  "source": "@site/blog/2024-02-25-dockview-1.10.0.md",
  "title": "Dockview 1.10.0",
  "description": "Please reference to docs @ dockview.dev.",
  "date": "2024-02-25T00:00:00.000Z",
  "formattedDate": "February 25, 2024",
  "tags": [
    {
      "label": "release",
      "permalink": "/blog/tags/release"
    }
  ],
  "readingTime": 0.915,
  "hasTruncateMarker": false,
  "authors": [],
  "frontMatter": {
    "slug": "dockview-1.10.0-release",
    "title": "Dockview 1.10.0",
    "tags": [
      "release"
    ]
  },
  "unlisted": false,
  "prevItem": {
    "title": "Dockview 1.10.1",
    "permalink": "/blog/dockview-1.10.1-release"
  },
  "nextItem": {
    "title": "Dockview 1.9.2",
    "permalink": "/blog/dockview-1.9.2-release"
  }
};
export const assets = {
"authorsImageUrls": [],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "🚀 Features",
  "id": "-features",
  "level": 2
}, {
  "value": "🛠 Miscs",
  "id": "-miscs",
  "level": 2
}, {
  "value": "🔥 Breaking changes",
  "id": "-breaking-changes",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Please reference to docs @ ", _jsx(_components.a, {
        href: "https://dockview.dev",
        children: "dockview.dev"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "-features",
      children: "🚀 Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["New Documentation Website ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/475",
          children: "#475"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Documentation website improved to cater for growing libary"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Panel Gaps ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/447",
          children: "#447"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["CSS Variable ", _jsx(_components.code, {
              children: "--dv-group-gap-size"
            }), " exposed."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Locked Dock ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/460",
          children: "#460"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "locked"
            }), " option prevents all user resizing of dock."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Enhance Window Popout ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/469",
          children: "#469"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Numerous improved to Window popouts including replacement of window to original location\nwhen popout is closed."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Enhance Events ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/479",
          children: "#479"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Drag and Drop Events ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/395",
          children: "#395"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-miscs",
      children: "🛠 Miscs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Bug: Drop Target Scaling ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/448",
          children: "#448"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Drop target overlays are no longer scaled with ", _jsx(_components.code, {
              children: "transform"
            }), " which allows for better CSS customization."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Bug: Popout ", _jsx(_components.code, {
          children: "always"
        }), " rendeing mode ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/486",
          children: "#486"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "always"
            }), " render mode now works in Popout Windows too."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Bug: React Component Support ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/498",
          children: "#498"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Support components wrapped with ", _jsx(_components.code, {
              children: "React.memo(...)"
            }), " passed in ", _jsx(_components.code, {
              children: "components"
            }), " option."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Bug: Remove Source Maps ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/509",
          children: "#509"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Source maps do not currently work. They have been removed and will be re-evaluated for a later release."
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-breaking-changes",
      children: "🔥 Breaking changes"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Bug: Typo ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/495",
          children: "#495"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Rename ", _jsx(_components.code, {
              children: "onDidMaxmizedNodeChange"
            }), " to ", _jsx(_components.code, {
              children: "onDidMaximizedNodeChange"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["Rename ", _jsx(_components.code, {
              children: "exitMaxmizedGroup"
            }), " to ", _jsx(_components.code, {
              children: "exitMaximizedGroup"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["Rename ", _jsx(_components.code, {
              children: "onDidMaxmizedGroupChange"
            }), " to ", _jsx(_components.code, {
              children: "onDidMaximizedGroupChange"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

